import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpLoadingProps } from '../common';

const Wrapper = styled.div<{ reverse?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  gap: var(--cp-spacing-07);

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
`;

const Title = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    display: block;
    height: 32px;
    width: 100% !important;
  }
  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
  margin-bottom: var(--cp-spacing-04);
`;

const Desc = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    display: block;
    height: 48px;
    width: 100% !important;
  }
  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
    height: 100% !important;
  }
  margin-bottom: var(--cp-spacing-04);
`;

const Content: React.FC = () => {
  return (
    <ContentWrapper>
      <Skeleton.Input active />
      <Title active />
      <Desc active />
    </ContentWrapper>
  );
};

const ImageSkeleton = styled(Skeleton.Image)`
  &.ant-skeleton,
  .ant-skeleton {
    width: 100% !important;
    height: 300px !important;
  }

  .ant-skeleton-image {
    width: 100% !important;
    height: 100% !important;
  }
`;

const Image: React.FC = () => {
  return (
    <ImageWrapper>
      <ImageSkeleton />
    </ImageWrapper>
  );
};

export const CpFeatureLoading: React.FC<CpLoadingProps> = ({
  styles,
  variantType,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <Wrapper
        reverse={variantType === CpWidgetVariantType.FeatureWithImageOnLeft}
      >
        <Content />
        <Image />
      </Wrapper>
    </CpSectionWrapper>
  );
};
